<template>
	<div class="relative-position">
		<template v-for="(t, index) in timeline.ev" :key="index">
			<q-card
				v-if="getActivityDescription(t)"
				:dark="isMobile"
				class="shadow-transition q-mb-md q-px-md"
				@click="openActivity(t)"
			>
				<q-list dense>
					<q-item>
						<q-item-section thumbnail class="relative-position image-tl">
							<img :src="getImageUrl(t.im)" v-if="t.im" />
							<img :src="getPlaceholder(t)" v-if="!t.im" />
						</q-item-section>

						<q-item-section>
							<q-item-label>
								<span v-html="getActivityDescription(t)" />
							</q-item-label>
						</q-item-section>

						<q-item-section caption side>
							{{ $dateUtil.fDateTimeAgo(t.d) }}
						</q-item-section>
					</q-item>
				</q-list>
			</q-card>
		</template>

		<q-card :dark="isMobile" class="shadow-transition q-mb-md" v-if="timeline.ev.length === 0">
			<q-list>
				<q-item>
					<q-item-section>
						<q-item-label :class="isMobile ? 'text-white' : 'text-grey-9'">
							{{ $t('no_events_in_your_activity_feed_come_back_later') }}
						</q-item-label>
					</q-item-section>
				</q-item>
			</q-list>
		</q-card>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from 'src/boot/firebase'
import { doc, onSnapshot } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

export default {
	name: 'UserActivityFeed',

	data() {
		return {
			activities: [],
			badges: [],
			loading: false,
			timeline: {
				ev: [],
			},
		}
	},

	computed: {
		...mapGetters({
			user_firebase_document: 'common/user_firebase_document',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			languages: 'params/languages',
			id_user_language_selected: 'common/id_user_language_selected',
		}),

		isMobile() {
			return this.$q.platform.is.mobile
		},

		getClientByIdClientSelected() {
			return this.clients.find((obj) => obj.id == this.id_user_client_selected)
		},
	},

	methods: {
		getActivityDescription(activity) {
			switch (activity.s) {
				case 'gtp':
					return `${this.$t('the_training')} <span class='text-bold'>${
						activity.p.t
					}</span> ${this.$t('was_published')}.`

				case 'gtur':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'earned_a_certification_on_the_training'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'gtul':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'liked_the_training'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'gtus':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'evaluated_the_training'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'gtuf':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'favorited_the_training'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'ppul':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'liked_the_podcast'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'ppus':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'evaluated_the_podcast'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'ppuf':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'favorited_the_podcast'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'tp':
					return `${this.$t('the_trail')} <span class='text-bold'>${activity.p.t}</span> ${this.$t(
						'was_published_f'
					)}.`

				case 'tur':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'earned_a_certification_on_the_trail'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'tul':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'liked_the_trail'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'tus':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'evaluated_the_trail'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'tuf':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'favorited_the_trail'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'lfp':
					return `${this.$t('the_file')} <span class='text-bold text-underline'>${
						activity.p.t
					}</span> ${this.$t('was_published_on_the_library')}.`

				case 'bu':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'earned_the_badge'
					)} <span class='text-bold'>${this.getBadgeTitle(activity.i)}</span>.`

				case 'wcp':
					return `${this.$t('the_webinar')} <span class='text-bold'>${
						activity.p.t
					}</span> ${this.$t('was_published')}.`

				case 'nc':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'commented_the_news'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'lcul':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'liked_the_live_class'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'lcus':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'evaluated_the_live_class'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'peus':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'liked_the_presential_event'
					)} <span class='text-bold'>${activity.p.t}</span>.`

				case 'peul':
					return `<span class='text-bold text-underline'>${activity.p.n}</span> ${this.$t(
						'evaluated_the_presential_event'
					)} <span class='text-bold'>${activity.p.t}</span>.`
			}
		},
		getPlaceholder(activity) {
			const obj = this.getClientByIdClientSelected
			const placeholderMap = {
				gtp: obj.group_training_placeholder,
				gtur: obj.group_training_placeholder,
				gtul: obj.group_training_placeholder,
				gtuf: obj.group_training_placeholder,
				gtus: obj.group_training_placeholder,
				lcul: obj.live_class_placeholder,
				lcus: obj.live_class_placeholder,
				peus: obj.presential_event_placeholder,
				peul: obj.presential_event_placeholder,
				tp: obj.trail_placeholder,
				tur: obj.trail_placeholder,
				tul: obj.trail_placeholder,
				tuf: obj.trail_placeholder,
				tus: obj.trail_placeholder,
				ppul: obj.podcast_placeholder,
				ppuf: obj.podcast_placeholder,
				ppus: obj.podcast_placeholder,
				lfp: obj.group_library_file_placeholder,
				nc: obj.news_placeholder,
				wcp: obj.webcast_placeholder,
				bu: process.env.BUCKET_URL + activity.im,
			}

			if (placeholderMap[activity.s] === 'https://image.jpg') return
			else return placeholderMap[activity.s]
		},
		getImageUrl(image) {
			if (image.search('media/') === 0) {
				return
			}
			return `${process.env.SITE_URL}/${image}`
		},

		getBadges() {
			this.$axios
				.get(`/etraining_badges/badges/`)
				.then((response) => {
					this.badges = response.data
				})
				.catch((e) => {
					console.log(e)
				})
		},

		getBadgeTitle(id) {
			let obj = this.badges.find((obj) => {
				return obj.id === id
			})
			if (obj) {
				let lang = obj.badge_languages.find((l) => {
					return l.language === this.id_user_language_selected
				})
				if (lang) return lang.title
			}
			return ''
		},

		openActivity(activity) {},
	},

	watch: {
		user_firebase_document: {
			handler: function (newValue) {
				this.timeline = []
				this.loading = true
				getAuth()
				onSnapshot(doc(db, 'timeline', `${this.user_firebase_document}`), (doc) => {
					if (doc.data()) this.timeline = doc.data()
					this.loading = false
				})
			},
			deep: true,
		},
	},

	created() {
		this.getBadges()
		this.loading = true
		getAuth()
		onSnapshot(doc(db, 'timeline', `${this.user_firebase_document}`), (doc) => {
			if (doc.data()) this.timeline = doc.data()
			this.loading = false
		})
	},
}
</script>

<style lang="scss" scoped>
.image-tl {
	width: 80px;
	height: 80px;

	img {
		width: 80%;
		height: auto;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
}
</style>
